import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private appPagesSubject = new BehaviorSubject<any[]>([
    {
      title: 'Mis propiedades',
      url: '/properties',
      icon: 'business',
      active: true
    }, {
      title: 'Configuración',
      url: '/user-config',
      icon: 'settings',
      active: false
    }, {
      title: 'Centro de ayuda',
      url: '/help-center',
      icon: 'help-circle',
      active: false
    },
    {
      title: 'Cerrar sesión',
      url: '',
      icon: 'log-out',
    }
  ]);

  appPages$ = this.appPagesSubject.asObservable();
  versionSelected: string;

  constructor(
    private translate: TranslateService
  ) {}

  async menuTranslate() {
    const updatedAppPages = [
      { ...this.appPagesSubject.value[0], title: this.translate.instant('app-component.Mis propiedades') },
      { ...this.appPagesSubject.value[1], title: this.translate.instant('app-component.Configuración') },
      { ...this.appPagesSubject.value[2], title: this.translate.instant('app-component.Centro de ayuda') },
      { ...this.appPagesSubject.value[3], title: this.translate.instant('app-component.Cerrar sesión') }
    ];
    this.appPagesSubject.next(updatedAppPages);
  }
}
